var _mask, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoOnly = function SvgLogoOnly(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26.5892V26.5892H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.589 13.2943C26.589 20.637 20.6368 26.5892 13.2947 26.5892C5.95192 26.5892 -0.000244141 20.637 -0.000244141 13.2943C-0.000244141 5.95152 5.95192 0 13.2947 0C20.6368 0 26.589 5.95152 26.589 13.2943Z",
    fill: "#36A9E0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1723 17.2995L13.1204 10.9256L9.345 17.2754C9.17849 17.5554 8.8831 17.7261 8.56489 17.7261H5.17017L11.6081 6.74835C11.9131 6.23527 12.4572 5.91818 13.0467 5.90882C13.633 5.90166 14.189 6.20004 14.5092 6.70431L21.4191 17.7261H17.9375C17.6291 17.7261 17.3415 17.5658 17.1723 17.2995Z",
    fill: "#FDFBFC"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoOnly);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoOnly.696b2134b18b7e4e6cf561536fca8378.svg";